import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';

export default function EmsculptNEOMuscleBuildAndFatReductionOne() {
    const { t } = useTranslation();
        const accodirons = [
        {
            title: t('what'),
            content: t('emsella.what')
        },
        {
            title: t('how'),
            content: t('emsella.how')
        },
        {
            title: t('benefits'),
            content: t('emsella.benefits')
        },
        {
            title: t('zone'),
            content: t('emsella.zone')
        },
        // {
        //     title: t('pairs'),
        //     content: t('pairs')
        // },
        {
            title: t('when_expected_results'),
            content: t('emsella.expected_results')
        },
        {
            title: t('results'),
            content: t('emsella.results')
        },
    ]

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('emsella.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('emsella.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('emsella.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('emsella.sessions'),
        }
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} alt='' src={`${process.env.REACT_APP_API_URL}/images/2025/12/Emsella_main.png`} width={1} height={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection
                    titleSize={{ md: 4, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: t('bodyherapies'),
                        title: t('emsella.mainTitle'),
                        description: t('emsella.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMSELLA")}`,
                        // learnUrl: "/"
                        price: `${t('price_session')} €60\n${t('price_package')} 6 ${t('price_seanc')}: €300`,

                        doctorIncluded: true
                    }}
                />
            </Box>

            <Box marginTop={{ md: '98px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            {/* <Grid container spacing={4} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{ md: '114px', xs: '50px' }}>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid> */}

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '140px', xs: '50px' }}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMSELLA")}`,
                            type: t('emsella.tech'),
                            // learn: '/',
                            title: t('emsella.techTitle'),
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 12, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}images/2026/05/img_6a0702ad152992.57359293.jpeg`,
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('emsella.techDesc')
                        }}
                        extraStyle={{
                            background: 'rgba(30, 53, 61, 1)'
                        }}
                        bgColor={'rgb(30, 53, 61)'}
                    />
                </Box>
            </Box>

            {/* <Grid container className='generalContainer' sx={{ marginX: 'auto' }} gap={'20px'} marginTop={{ md: '77px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '1.125rem', xs: '1rem' }}>
                        What It Involves
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                        You simply sit on the Emsella chair with the center of the device positioned under your pelvic floor. For twenty eight minutes the chair delivers focused electromagnetic pulses that trigger thousands of deep muscle contractions. It feels like rhythmic tightening or vibration rather than pain. Each session is equivalent to about eleven thousand Kegel contractions, activating and re educating the pelvic floor more effectively than exercise alone.
                    </Typography>
                </Grid>
            </Grid> */}

            <Grid container gap={{ md: '80px', xs: '50px' }} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{ md: '110px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Box paddingTop={{ md: '127px', xs: '50px' }}>

            </Box>

            {/* <Box bgcolor={'#DBDAD9'} paddingY={'100px'} marginTop={{ md: '172px', xs: '50px' }} paddingTop={{ md: '127px', xs: '50px' }} paddingBottom={{ md: '222px', xs: '50px' }}>
                <Box className="generalContainer" marginX={'auto'} gap={{ md: '89px', xs: '50px' }} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            imageUrl: 'https://signup.rinu.me/images/2025/12/Vaginal-Laser.png',
                            type: 'Pairing',
                            title: 'Vaginal Laser',
                            description: 'Emsella pairs perfectly with our Vaginal Laser treatments: the laser improves tissue tightness and moisture, while Emsella builds muscle strength together addressing different aspects of intimate wellness.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            learn: "/skin/fractional-co2-resurfacing",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: 'https://signup.rinu.me/images/2025/12/Core.png',
                            type: 'Pairing',
                            title: 'Core Physical Therapy',
                            description: 'It’s also a great adjunct to core physical therapy or personal training if you’ve been doing Pilates for core strength, Emsella amplifies those benefits from the inside. The beauty is there’s no downtime or effort; you can literally do an Emsella session over a lunch break (bring a book or listen to music while the chair does the work!). Many patients then go straight to a body massage or other service since you’re just sitting, it doesn’t leave you sore, just pleasantly aware of your engaged muscles.',
                            learn: "/skin/hybrid-laser-erbium-glass",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box> */}
        </Box>
    )
}